module.exports = __webpack_public_path__ + "img/banner_2.73ba3c7b.jpg";